import React from 'react'
import './index.css';
export default function Title(props) {
  return (
    <div>
      <h1 class="title">{props.mainTitle}</h1>
    </div>
  )
}
